import { Col, Input, Row, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { t } from "i18next";
import React from "react";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import HeaderPages from "../../../../component/page-components/pages-header";
import useAddUOM from "./add-uom.hooks";
import useDetailUOM from "../detail/detail-uom.hooks";
import NotifAddSuccess from "../../../../component/modal/NotifAddSuccess";
import NotifFailedSaved from "../../../../component/modal/NotifFailedSaved";
import { ROUTES } from "../../../../constant/routeConstant";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";

const AddUOM = () => {
  const {
    backToList,
    _onChange,
    _onAdd,
    listCategory,
    form,
    err,
    error,
    failedModalOpen,
    successModalOpen,
    messageFailed,
    _onOkSuccesAdd,
    setFailedModalOpen,
    handleKeyPress,
    showConfirm,
    setShowConfirm,
  } = useAddUOM();

  const { UOMConvertions } = useDetailUOM();

  const NewHandleKeyPress = (event) => {
    const regex = /^[0-9,]+$/; // Regex yang diinginkan

    // Allow only number and comma input, but not at the beginning
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <>
      <div className="p-5 h-fit">
        <ModalConfirmLeave
          visible={showConfirm}
          action={() => setShowConfirm(false)}
          route={ROUTES.UOM.LIST}
        />

        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Units of Measurement`}
          menuLevel4={`Add UOM`}
        />
        <HeaderPages
          title="Add Units of Measurement"
          menuType="add"
          handleBack={backToList}
        />
        <div className=" bg-white-100 p-5 rounded-[10px] min-h-96 mt-5 pb-10">
          <p className="text-lg font-medium font-roboto text-black-100">
            Detail to Add UOM
          </p>
          <Row className="mt-5">
            <Col span={12}>
              <div>
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Category")}
                </p>
                <Select
                  style={{ width: "80%" }}
                  size="large"
                  options={listCategory}
                  value={form?.uom_category}
                  onChange={(evt) => {
                    _onChange(evt, "uom_category");
                  }}
                  placeholder="Select UOM Category"
                  status={error?.uom_category ? "error" : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.uom_category}
              </div>
              <div className="mt-4">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Name")}
                </p>
                <Input
                  style={{ width: "80%" }}
                  size="large"
                  value={form?.uom_name}
                  onChange={(evt) => {
                    _onChange(evt, "uom_name");
                  }}
                  placeholder={t("COMMON:TYPE", { field: t("UOM Name") })}
                  status={error?.uom_name ? "error" : null}
                />
              </div>
              <div className="text-red-100">{err ? err : error?.uom_name}</div>
              <div className="mt-4">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Category Code")}
                </p>
                <Input
                  style={{ width: "80%" }}
                  size="large"
                  maxLength={3}
                  value={form?.uom_category_code}
                  onChange={(evt) => {
                    _onChange(evt, "uom_category_code");
                  }}
                  placeholder={t("COMMON:TYPE", {
                    field: t("UOM Category Code"),
                  })}
                  status={error?.uom_category_code ? "error" : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.uom_category_code}
              </div>
              <div className="mt-4">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("UOM Conversions")}
                </p>
                <Row style={{ width: "80%" }}>
                  <Col span={6}>
                    <Row>
                      <Col span={10}>
                        <Input
                          style={{ borderRadius: "0px", textAlign: "center" }}
                          size="large"
                          value={1}
                          disabled
                        />
                      </Col>
                      <Col span={14}>
                        <Input
                          style={{ borderRadius: "0px", textAlign: "center" }}
                          size="large"
                          value={form?.uom_category_code}
                          defaultValue="X"
                          disabled
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    span={2}
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    <p className="font-roboto-medium text-[16px] text-[#1D1D1D]">
                      =
                    </p>
                  </Col>
                  <Col span={16}>
                    <Input
                      size="large"
                      addonAfter={UOMConvertions(form?.uom_category)}
                      placeholder="Fill Category & Code First"
                      value={form?.uom_conversions_to}
                      disabled={
                        form?.uom_category && form?.uom_category_code
                          ? false
                          : true
                      }
                      onChange={(evt) => {
                        _onChange(evt, "uom_conversions_to");
                      }}
                      onKeyPress={(evt) => NewHandleKeyPress(evt)}
                      showCount={false}
                      status={error?.uom_conversions_to ? "error" : null}
                    />
                  </Col>
                </Row>
              </div>
              <div className="text-red-100">
                {err ? err : error?.uom_conversions_to}
              </div>
              <div className="mt-4">
                <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                  {t("Description UOM")}
                </p>
                <TextArea
                  style={{ width: "80%" }}
                  size="large"
                  value={form?.uom_description}
                  onChange={(evt) => {
                    _onChange(evt, "uom_description");
                  }}
                  placeholder={t("COMMON:TYPE", {
                    field: t("LOGIN_COMPLETION:LBL_ADDRESS"),
                  })}
                  status={error?.uom_description ? "error" : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.uom_description}
              </div>
            </Col>
            <Col span={12}></Col>
          </Row>
        </div>
      </div>
      <div className="flex flex-row-reverse gap-[16px] px-5 m-5">
        <PrimaryButton action={_onAdd} text={t("COMMON:BTN_ADD")} />
        <SecondaryButton action={backToList} text={t("COMMON:CANCEL")} />
      </div>
      <NotifAddSuccess
        visible={successModalOpen}
        menu={`${form?.uom_name} - ${form?.uom_category_code}`}
        action={_onOkSuccesAdd}
      />
      <NotifFailedSaved
        visible={failedModalOpen}
        message={messageFailed}
        action={() => {
          setFailedModalOpen(false);
        }}
      />
    </>
  );
};

export default AddUOM;
